import React, { Suspense, useMemo, useState } from 'react';
import FloatingButton from '../../../../components/ui/materialui/floatingButton';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import { Box, Paper } from '@mui/material';
import Breadcrumb from '../../../../components/ui/materialui/breadcrumb';
import Tabla from '../../../../components/ui/materialui/serverSideTable';
import { useDataFetch } from '../../../../hooks/useDataFetch2';
import { responsables, responsablesEditar } from '../models/responsables';
import { useColumns } from '../utils/columns';
import TableHeader from '../../../../components/ui/materialui/tableHeader';
import { exportExcel } from '../../../../utils/exportExcel';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import ModalResponsables from '../components/modalResponsables';
import { PermissionGuard } from '../../../../components/auth/ProtectedRoute';
import { TipoFuncionalidad } from '../../../../utils/enums';



function Responsables() {

  const [isLoading, setIsLoading] = React.useState(false)
  const [refresh, setRefresh] = useState(false)

  const [modalDetalle, setModalDetalle] = useState<boolean>(false)
  const [responsableEditar, setResponsablesEditar] = useState<responsables>()

  const urlTabla = `siscred-api-maestros/v1/responsables/listar`;

  const control = useDataFetch(
    urlTabla,
    new URLSearchParams('filters.status=ACTIVA'),
    true,
  )

  const { COLUMNS } = useColumns({ control, setResponsablesEditar, setModalDetalle });
  const columns = useMemo(() => COLUMNS, [control]);

  const breadcrumbItems = [
    { label: 'Inicio', url: '/' },
    { label: 'Maestros', url: `/maestros` },
    { label: 'Responsables', active: true },
  ]

  return (
    <>
      <Suspense>
        <Breadcrumb items={breadcrumbItems} />
        <Box sx={{ mt: 2 }}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Suspense>
              <Tabla
                columns={columns}
                control={control}
                url={urlTabla}
                titulo={
                  <TableHeader
                    title=""
                    control={control}
                    button={
                      <PermissionGuard permissions={[TipoFuncionalidad.Maestros_editar]}>
                      <MButton
                        type="button"
                        variant="contained"
                        onClick={() => { setModalDetalle(true); setResponsablesEditar(undefined); }}
                        startIcon={<AddTwoToneIcon />}
                      >
                        Nuevo
                      </MButton>
                      </PermissionGuard>
                    }
                    buttonExport={
                      <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                      <MButton
                        type="button"
                        variant="outlined"
                        onClick={() => exportExcel(control.data, columns, "RESPONSABLES")}
                        startIcon={<SummarizeTwoToneIcon />}
                      >
                        Exportar
                      </MButton>
                      </PermissionGuard>
                    }
                  />
                }
              />
            </Suspense>
          </Paper>
        </Box>

        <ModalResponsables
          show={modalDetalle}
          datosEditar={responsableEditar}
          onHide={() => setModalDetalle(false)}
          refresh={() => control.fetchData()}
          setisloading={setIsLoading}
          setrefresh={setRefresh}
        />
      </Suspense>

    </>
  );
}

export default Responsables;
